import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagTK = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M40.217 11.957a16.683 16.683 0 0 0-.326 3.37c0 6.594 3.932 12.302 9.566 14.872.355-1.677.543-3.416.543-5.199C50 11.193 38.807 0 25 0S0 11.193 0 25s11.193 25 25 25c8.563 0 16.119-4.306 20.625-10.87H14.13v-3.26h33.39c.341-.707.65-1.432.925-2.174H14.13l26.087-21.74Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m18.366 13.044.54 1.66h1.746l-1.413 1.027.54 1.66-1.413-1.026-1.412 1.027.54-1.661-1.414-1.027h1.747l.54-1.66ZM11.272 25l.674 2.076h2.183l-1.766 1.283.675 2.076-1.766-1.283-1.766 1.283.674-2.076-1.765-1.283h2.182L11.272 25ZM11.272 7.609l.674 2.076h2.183l-1.766 1.282.675 2.076-1.766-1.283-1.766 1.283.674-2.076-1.765-1.282h2.182l.675-2.076ZM5.838 17.392l.674 2.076h2.183L6.929 20.75l.675 2.076-1.766-1.283-1.766 1.283.674-2.076-1.765-1.282h2.182l.675-2.076Z"
}));
FlagTK.displayName = 'FlagTK';
export default withFlagWrapper(FlagTK);
//# sourceMappingURL=index.js.map